'use client';

import { c as _c } from "react/compiler-runtime";
import { type AriaToastProps, useToast } from '@react-aria/toast';
import { type ToastState } from '@react-stately/toast';
import classnames from 'classnames';
import { useRef } from 'react';
import { AlertIcon, CancelIcon, InformationIcon, SuccessIcon } from '../svgs';
import { type ToastContent, ToastType } from './constants/constants';
import styles from './toast.module.scss';
type ToastProps = AriaToastProps<ToastContent> & {
  state: ToastState<ToastContent>;
};
const getToastIcon = (type?: ToastType) => {
  const iconClassName = styles['toast__icon'];
  switch (type) {
    case ToastType.ERROR:
      return <AlertIcon className={iconClassName} />;
    case ToastType.SUCCESS:
      return <SuccessIcon className={iconClassName} />;
    case ToastType.INFO:
    default:
      return <InformationIcon className={iconClassName} />;
  }
};
export const Toast = t0 => {
  const $ = _c(24);
  let props;
  let state;
  if ($[0] !== t0) {
    ({
      state,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = state;
  } else {
    props = $[1];
    state = $[2];
  }
  const ref = useRef(null);
  const {
    descriptionProps,
    toastProps
  } = useToast(props, state, ref);
  const {
    content,
    key
  } = props.toast;
  const {
    closeButtonLabel,
    description,
    isCloseButtonVisible: t1,
    type
  } = content;
  const isCloseButtonVisible = t1 === undefined ? true : t1;
  const t2 = type === ToastType.ERROR;
  const t3 = type === ToastType.INFO;
  const t4 = type === ToastType.SUCCESS;
  const t5 = !isCloseButtonVisible;
  let t6;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = classnames(styles.toast, {
      [styles["toast--error"]]: t2,
      [styles["toast--info"]]: t3,
      [styles["toast--success"]]: t4,
      [styles["toast--without-close-button"]]: t5
    });
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== type) {
    t7 = getToastIcon(type);
    $[8] = type;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== description || $[11] !== descriptionProps) {
    t8 = <p className={styles.toast__message} {...descriptionProps}>{description}</p>;
    $[10] = description;
    $[11] = descriptionProps;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== closeButtonLabel || $[14] !== isCloseButtonVisible || $[15] !== key || $[16] !== state) {
    t9 = isCloseButtonVisible && <div className={styles["toast__actions-container"]}><div className={styles.toast__separator} /><button aria-label={closeButtonLabel} className={styles["toast__close-button"]} onClick={() => state.close(key)}><CancelIcon /></button></div>;
    $[13] = closeButtonLabel;
    $[14] = isCloseButtonVisible;
    $[15] = key;
    $[16] = state;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9 || $[22] !== toastProps) {
    t10 = <div {...toastProps} className={t6} ref={ref}>{t7}{t8}{t9}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = toastProps;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};